import { parseUnits, } from "viem";

export declare type AmountStringToBiOptions = {
	precision?: number;
}

export const amountStringToBi = ( amount: string, decimals: number ) => {
	return parseUnits(amount, decimals);
}
